var React = require('react');

function ArrowAlternate (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.1682 8.70711C18.5587 8.31658 18.5587 7.68342 18.1682 7.29289L11.8042 0.928932C11.4137 0.538408 10.7805 0.538408 10.39 0.928932C9.9995 1.31946 9.9995 1.95262 10.39 2.34315L16.0469 8L10.39 13.6569C9.9995 14.0474 9.9995 14.6805 10.39 15.0711C10.7805 15.4616 11.4137 15.4616 11.8042 15.0711L18.1682 8.70711ZM1.8457 7C1.29342 7 0.845703 7.44772 0.845703 8C0.845703 8.55228 1.29342 9 1.8457 9V7ZM17.4611 7H1.8457V9H17.4611V7Z"}));
}

ArrowAlternate.defaultProps = {"width":"19","height":"16","viewBox":"0 0 19 16","fill":"none","aria-hidden":"true"};

module.exports = ArrowAlternate;

ArrowAlternate.default = ArrowAlternate;
